import React from "react";
const icon = (
  <svg
    width="448"
    height="448"
    viewBox="0 0 448 448"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64 0C28.7 0 0 28.7 0 64V384C0 419.3 28.7 448 64 448H384C419.3 448 448 419.3 448 384V64C448 28.7 419.3 0 384 0H64ZM337 177L209 305C199.6 314.4 184.4 314.4 175.1 305L111.1 241C101.7 231.6 101.7 216.4 111.1 207.1C120.5 197.8 135.7 197.7 145 207.1L192 254.1L303 143C312.4 133.6 327.6 133.6 336.9 143C346.2 152.4 346.3 167.6 336.9 176.9L337 177Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
